import { render, staticRenderFns } from "./CreateNewResources.vue?vue&type=template&id=21705883&scoped=true&"
import script from "./CreateNewResources.vue?vue&type=script&lang=js&"
export * from "./CreateNewResources.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewResources.vue?vue&type=style&index=0&id=21705883&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21705883",
  null
  
)

export default component.exports